export default __webpack_public_path__ + "static/media/confirma.a2e66fc7.mp3";